// Funciones para validar el formato del correo electrónico y el número de teléfono
export const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

export const isValidPhone = (phone) => {
  const digits = phone.replace(/\D/g, "");
  return digits.length === 10;
};
